enum PaymentMethodType {
    ApplePay = 'applepay',
    Barclaycard = 'barclaycard',
    CreditCard = 'credit-card',
    GooglePay = 'googlepay',
    PayWithGoogle = 'paywithgoogle',
    Masterpass = 'masterpass',
    MultiOption = 'multi-option',
    Paypal = 'paypal',
    PaypalCredit = 'paypal-credit',
    PaypalVenmo = 'paypal-venmo',
    VisaCheckout = 'visa-checkout',
}

export default PaymentMethodType;
